<div class="d-flex flex-wrap" *ngIf="categories">
  <ng-container *ngIf="collapsed">
    <ng-container *ngIf="previewIndices.length > categories.length">
      <ng-container *ngFor="let category of categories">
        <div class="pr-1 pt-1">
          <py-price-file-category-badge
            [disabled]="disabled"
            [label]="category.name"
            [picked]="isPicked(category)"
            (pick)="pick($event, category)"
          ></py-price-file-category-badge>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="previewIndices.length <= categories.length">
      <ng-container *ngFor="let ix of previewIndices">
        <div class="pr-1 pt-1">
          <py-price-file-category-badge
            [disabled]="disabled"
            [label]="categories[ix].name"
            [picked]="isPicked(categories[ix])"
            (pick)="pick($event, categories[ix])"
          ></py-price-file-category-badge>
        </div>
      </ng-container>
    </ng-container>
    <div *ngIf="categories.length > previewIndices.length" class="pt-1">
      <py-price-file-category-badge
        [label]="remaining()"
        [disabled]="false"
        [picked]="selectedCategories.length === categories.length"
        [toggleBadge]="true"
        (click)="toggleCategories()"
      ></py-price-file-category-badge>
    </div>
    <button
      *ngIf="categories.length > previewIndices.length"
      class="pt-1 ml-auto"
      type="button"
      [attr.aria-label]="'priceFiles.expandCategoryList_action' | cxTranslate"
      (click)="toggleCategories()"
    >
      <i nz-icon nzType="down" nzTheme="outline"></i>
    </button>
  </ng-container>
  <ng-container *ngIf="!collapsed">
    <ng-container *ngFor="let category of categories">
      <div class="pr-1 pt-1">
        <py-price-file-category-badge
          [disabled]="disabled"
          [picked]="isPicked(category)"
          (pick)="pick($event, category)"
          [label]="category.name"
        ></py-price-file-category-badge>
      </div>
    </ng-container>
    <button
      class="pt-1 ml-auto"
      type="button"
      [attr.aria-label]="'priceFiles.collapseCategoryList_action' | cxTranslate"
      (click)="toggleCategories()"
    >
      <i nz-icon nzType="up"></i>
    </button>
  </ng-container>
</div>
